import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vle',
  templateUrl: './vle.component.html',
  styleUrls: ['./vle.component.css']
})
export class VleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/vle/vle.component.ts